import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

/**
 * referer - the service that made the request
 * contentTypePrefix - being 'image/', 'application/', 'text/'
 * fileName - fileName including extension: eg, blah.json or blah.png
 */
export interface FileUploadRequestData {
  readonly accessToken: string
  readonly referer: string,
  readonly contentType: string,
  readonly fileName: string,
  readonly file: any
}

export interface FileUploadResponseItem {
  readonly referer: string
  readonly name: string
  readonly url: string
}


export interface FileUploadState {
  fileItems: FileUploadResponseItem[]
  currentItem?: FileUploadResponseItem
  status: 'idle' | 'pending' | 'succeeded' | 'failed'
  error: null | string
}


const initialState: FileUploadState = {
  fileItems: [],
  status: 'idle',
  error: null
} as FileUploadState;

export const uploadFile = createAsyncThunk<FileUploadResponseItem, FileUploadRequestData, { rejectValue: { readonly errorMessage: string } }>(
  'files/put',

  async (arg, thunkAPI) => {

    return await fetch(
      `/api/files/${arg.fileName}`,
      {
        method: 'POST',
        body: arg.file,
        headers: {
          'Authorization': `Basic ${arg.accessToken}`,
          'Content-Type': arg.contentType,
        },

      })

      .then(response => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error(`Unexpected response from server (code ${response.status}).`);
        }
      })

      .catch(function (error) {
        console.error(error);
        return thunkAPI.rejectWithValue({ errorMessage: error.message });
      });
  }
);


export const fileSlice = createSlice({
  name: 'emailstate', // not sure what this 'name' is for. For the moment, I'll just call it the same as the reference in store.ts
  initialState,
  reducers: {
    resetState: () => initialState,
    findUploaded: (state, action) => {
      state.currentItem = state.fileItems.find(f => f.name === action.payload)
    }
  },
  extraReducers: (builder) => {
    builder
    .addCase(uploadFile.pending, (state) => {
      state.status = 'pending';
    })
    .addCase(uploadFile.fulfilled, (state, action) => {
      state.fileItems.push(action.payload);
      state.error = '';
      state.status = 'succeeded';
    })
    .addCase(uploadFile.rejected, (state, action) => {
      if (action.payload !== undefined) {
          state.error = action.payload.errorMessage;
      }
      state.status = 'failed';
    })

  },
  
});

export const {resetState, findUploaded} = fileSlice.actions


export default fileSlice.reducer;